// extracted by mini-css-extract-plugin
export default {"wrap":"MessagesPage_wrap__LHqzZ","panelChat":"MessagesPage_panelChat__Nk33D","panelStudentInfo":"MessagesPage_panelStudentInfo__4zQmk"};